module.exports = __webpack_public_path__ + "img/beautiful-young-female-company-ceo-successful-business-lady-work-119168602.beae554c.jpg";